// Admin settings utilities

export const calculateStorageUsage = () => {
  let total = 0;
  for (let key in localStorage) {
    if (Object.prototype.hasOwnProperty.call(localStorage, key)) {
      total += localStorage[key].length;
    }
  }
  return (total / 1024).toFixed(2); // KB
};

export const getDefaultSettings = () => ({
  siteTitle: 'aiximo',
  siteDescription: 'AI-powered software development agency',
  contactEmail: 'info@aiximo.com',
  enableNotifications: true,
  autoBackup: true,
  maintenanceMode: false
});

export const loadSettings = () => {
  try {
    const saved = localStorage.getItem('admin_settings');
    return saved ? JSON.parse(saved) : getDefaultSettings();
  } catch (error) {
    console.error('Failed to load settings:', error);
    return getDefaultSettings();
  }
};

export const saveSettings = (settings) => {
  try {
    localStorage.setItem('admin_settings', JSON.stringify(settings));
    return {success: true};
  } catch (error) {
    console.error('Failed to save settings:', error);
    return {success: false, error: error.message};
  }
};